import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'

import { loadCommentsForIssue } from '../../actions/comments'

import IssueComments from '../../components/issues/issue-comments'

function mapStateToProps (state, ownProps) {
  const pagination = get(state, `pagination.commentsByIssue.${ownProps.issue.id}`, {})
  const comments = at(state.comments, pagination.ids || [])

  return {
    comments,
    hasNextPage: pagination.nextPageUrl
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(loadCommentsForIssue(ownProps.issue.id))

  return {
    onLoadNextPage () {
      dispatch(loadCommentsForIssue(ownProps.issue.id, true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueComments)



// WEBPACK FOOTER //
// ./src/containers/issues/issue-comments-container.js